import React, { useState } from 'react';
import './AddDetails.css';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

const AddDetails = ({ fetchData }) => {
  const [deviceDetails, setDeviceDetails] = useState({
    deviceId: '',
    model: '',
    brand: '',
    mac: ['', '', '', '', '', ''],
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDeviceDetails((prev) => ({ ...prev, [name]: value.toUpperCase() }));
  };

  const handleMacChange = (index, value, nextInput) => {
    const validMacPattern = /^[A-Za-z0-9]{0,2}$/;

    if (validMacPattern.test(value)) {
      setDeviceDetails((prev) => {
        const mac = [...prev.mac];
        mac[index] = value.toUpperCase();
        return { ...prev, mac };
      });

      if (value.length === 2 && nextInput) {
        nextInput.focus();
      }
    }
  };

  const handleMacKeyDown = (index, event, prevInput) => {
    if (event.key === 'Backspace' && deviceDetails.mac[index] === '' && prevInput) {
      prevInput.focus();
    }
  };

  const isFormComplete =
    deviceDetails.deviceId &&
    deviceDetails.model &&
    deviceDetails.brand &&
    deviceDetails.mac.every((part) => part.length === 2);

  const resetForm = () => {
    setDeviceDetails({
      deviceId: '',
      model: '',
      brand: '',
      mac: ['', '', '', '', '', ''],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      const session = await fetchAuthSession();
      const user = await getCurrentUser();
      const token = session.tokens?.idToken?.toString();
      const formattedMac = deviceDetails.mac.join(':');

      const payload = {
        username: user?.username,
        token: token,
        deviceId: deviceDetails.deviceId,
        dev_active_status: true,
        device: {
          mfr: deviceDetails.brand,
          brand: deviceDetails.model,
          mac_id: formattedMac,
        },
      };

      const response = await fetch('https://6vpgfpbqbg.execute-api.ap-south-1.amazonaws.com/Adddetails', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();

      if (response.ok) {
        alert('Device details added successfully!');
        resetForm();
        fetchData(); // ✅ Update GetDetail after successful addition
      } else {
        setErrorMessage(responseData.message || 'Failed to add device');
      }
    } catch (error) {
      console.error('Submission failed:', error);
      setErrorMessage('Failed to add device details.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-details-container">
      {errorMessage && (
        <div className="error-popup">
          <div className="error-box">
            <p>{errorMessage}</p>
            <button className="close-btn" onClick={() => setErrorMessage('')}>✖</button>
          </div>
        </div>
      )}

      <form className="device-form" onSubmit={handleSubmit}>
        <h2>Add Device</h2>

        <label>Device ID:</label>
        <input type="text" name="deviceId" value={deviceDetails.deviceId} onChange={handleChange} required />

        <label>Model:</label>
        <input type="text" name="model" value={deviceDetails.model} onChange={handleChange} required />

        <label>Brand:</label>
        <input type="text" name="brand" value={deviceDetails.brand} onChange={handleChange} required />

        <label>MAC ID:</label>
        <div className="mac-id-container">
          {deviceDetails.mac.map((part, index) => (
            <input
              key={index}
              type="text"
              maxLength="2"
              value={part}
              onChange={(e) =>
                handleMacChange(index, e.target.value, document.getElementById(`mac-${index + 1}`))
              }
              onKeyDown={(e) => handleMacKeyDown(index, e, document.getElementById(`mac-${index - 1}`))}
              required
              id={`mac-${index}`}
            />
          ))}
        </div>

        <p className="mac-note">Only 0 to 9 and A to Z are valid inputs in MAC ID</p>

        <button type="submit" className="submit-btn" disabled={!isFormComplete || loading}>
          {loading ? 'Submitting...' : 'Add Device'}
        </button>
      </form>
    </div>
  );
};

export default AddDetails;
